
<div class="container-fluid project-review">
    <div class="project-wrapper row" [ngClass]="{'is-open': menuOpen, 'collapsed': !menuOpen}">
      <div class="project-menu">
        <div class="project-title">
          <div class="menu-bars menu-bars--spring" (click)="toggleMenu()" [ngClass]="{'is-active': menuOpen}">
            <div class="menu-bars-box">
              <div class="menu-bars-inner"></div>
            </div>
          </div>
          <span class="font-bold">Project Name</span>
        </div>
        <div class="project-search-container">
          <span class="glyphicon glyphicon-search search-icon" [ngClass]="{'dark': mouseOverSearchBox}"></span>
          <input placeholder="Search" type="text" class="search-box" [(ngModel)]="projectSearchTerm"
                 (mouseenter)="mouseOverSearchBox = true;" (mouseleave)="mouseOverSearchBox = false;"/>
        </div>
        <div class="project-list-container">
          @if (projectListLoading) {
<div class="project-list-loader flex-center">
            <span>Loading...</span>
          </div>
}
          @if (!projectListLoading) {
<ul class="project-list">
            @for (project of projectList | filterfn: projectFilter : projectSearchTerm; track $index) {
<li
                [ngClass]="{'selected': project.selected}" (click)="selectProject(project)">
                  @if (menuOpen) {
<span id="{{project.project_id}}">
                      {{project.project_name}}
                  </span>
}
              @if (!menuOpen) {
<span class="text-uppercase">
                      {{project.label}}
                  </span>
}
            </li>
}
          </ul>
}
        </div>
      </div>
      <div class="project-details">
        <div class="btn-group right-header">
          <button id="transaction-step" class="project-header-btn btn-md"
                  (click)="selectTab(0)"
                  [ngClass]="{'project-header-btn--active' : tableIndex === 0}">
            Transaction By Step
          </button>
          <button id="transaction-data" class="project-header-btn btn-md"
                  (click)="selectTab(1)"
                  [ngClass]="{'project-header-btn--active' : tableIndex === 1}">
            Transaction Data
          </button>
        </div>
        @if (!selectedProject) {
<div class="project-details-no-selection flex-center">
          <span>Please select a project from the list.</span>
        </div>
}
        @if (selectedProject) {
<div class="project-table-container">
          @if (tableLoading) {
<div class="project-details-loader-container flex-center">
            <div><i class="fa fa-spinner fa-spin project-details-loader"></i></div>
          </div>
}

          @if (!tableLoading && tableIndex === 0) {
<gtw-ex-datatable [options]="transactionStepParentTable.options"
            class="project-review-datatable"
           
          ></gtw-ex-datatable>
}


          @if (!tableLoading && tableIndex === 1) {
<gtw-ex-datatable [options]="transactionDataParentTable.options"
            class="project-review-datatable"
           
          ></gtw-ex-datatable>
}

          <!-- see controller for datatable configurations -->
          <!-- <gt-datatable2 table-id="transactionStepTable" class="project-review-datatable"
                         *ngIf="!tableLoading && tableIndex === 0 && transactionStepParentTable.options.data"
                         options="transactionStepParentTable.options"
                         dt-instance="dtInstance">
          </gt-datatable2>
          <gt-datatable2 table-id="transactionDataTable" class="project-review-datatable"
                         *ngIf="!tableLoading && tableIndex === 1 && transactionDataParentTable.options.data"
                         options="transactionDataParentTable.options"
                         dt-instance="dtInstanceTransaction">
          </gt-datatable2> -->
        </div>
}
      </div>
    </div>
  </div>
